export const emailExistBuilderForUI = (data) => {
  return {
    isOktaEmailExist: !data.available,
    email: data.email,
  };
};
